const autoNgTemplateLoaderTemplate1 = require('./host-view.html');

angular.module('shbdeployer.docker').component('hostView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'HostViewController',
  bindings: {
    endpoint: '<',
  },
});
